import { ActionInput } from '../parts/index.js';

/** The maps ask afresh for each save, using the console's existing field kit. */
export function Reason({ value, onChange, busy }: { value: string; onChange: (value: string) => void; busy: boolean }) {
  return <label className="admin-find">Reason
    <ActionInput type="text" required maxLength={500} value={value} disabled={busy} onChange={event => onChange(event.target.value)} />
  </label>;
}
